module.exports = __webpack_public_path__ + "img/paia-manual.fe74b6ec.svg";